<template>
  <div id="contenedor-listado-videos">
    <v-row>
      <template
        v-for="video in listadoVideos">
        <template>
          <v-col
            cols="12"
            sm="6"
            md="3"
            :key="`video-${video.id}`">
            <v-card>
              <iframe
                v-if="video.url"
                :src="video.url"
                frameborder="0"
                width="100%"
                height="250">
              </iframe>
              <v-card-text>
                {{ video.descripcion }}
              </v-card-text>
              <v-card-actions>
                <fecha-humano
                  :fecha="video.fecha">
                </fecha-humano>
                <v-spacer></v-spacer>
                <v-btn icon v-bind="attrs" v-on="on" @click="editar(video)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>
      </template>
    </v-row>
  </div>
  <!-- <v-data-table :headers="headers" :items="listadoVideos">
    <template v-slot:[`item.createdAt`]="{ item }">
      <fecha-humano :fecha="item.createdAt"> </fecha-humano>
    </template>
    <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="verVideo(item)">
            <v-icon>mdi-youtube</v-icon>
          </v-btn>
        </template>
        <span>Ver Video</span>
      </v-tooltip>
      <template v-if="!soloLectura">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Borrar</span>
        </v-tooltip>
      </template>
    </template>
  </v-data-table> -->
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoVideos',
  props: {
    listadoVideos: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: 'Fecha', align: 'center', value: 'fecha' },
        {
          text: 'Descripcion',
          align: 'start',
          sortable: false,
          value: 'descripcion',
        },
        { text: 'URL', align: 'center', value: 'url' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(video) {
      eventBus.$emit('editar-video-contrato', video);
    },
    borrar(video) {
      eventBus.$emit('eliminar-video-contrato', video);
    },
    verVideo(video) {
      eventBus.$emit('ver-video-contrato', video);
    },
  },
};
</script>

<style lang="scss">
</style>
